import LinkHistoryTable from "./LinkHistoryTable";
export default LinkHistoryTable;
